import { BotaoPadrao } from '../../../../components/Botoes'
import React, { useState, useEffect } from 'react'
import { mostrarToast } from '../../../../components/Toasts'
import { Formik, Form } from "formik"
import { InputPadrao } from '../../../../components/Inputs'
import { getUsuario } from '../../../../util/Configuracoes'
import { mensagens } from '../../../../util/Utilitarios'
import { post, postComAcao } from '../../../../util/AcessoApi'
import Yup from '../../../../util/Validacoes'
import 'react-toastify/dist/ReactToastify.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../css/login.css'
import Atalho from '../../../../util/Atalho'
import { InputGroupSenha, TextArea } from '../../../../components/InputsV2'
import { ACOES, MODULO } from '../../../../util/Enums'


const AutorizacaoSenha = (props) => {
    let validacaoInicial = Yup.object({
        login: Yup.string()
            .required()
            .max(30),
        senha: Yup.string()
            .required()
            .max(30),
        justificativa: Yup.string()
            .required()
    })


    const [isSubmit, setIsSubmit] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})

    const { history } = props

    useEffect(() => {
        setValoresIniciais({
            usuario_solicitante_id: getUsuario().id,
            agenda_id: '',
            login: "",
            senha: "",
            justificativa: "",
        })
    }, [])


    const Submit = (values, setIsSubmit, setShow) => {
        setIsSubmit(true)
        Promise.resolve(postComAcao(ACOES.ADICIONAR_SOCIO_FORA_CORPO_CLINICO, 38, values, '/administracao/autorizarAcaoAgenda', function (val) {
            props.propsFormikOriginal.values.autorizacaoEscala = { ...val }
            setShow(false)
            props.setPermissaoConcedida(true)
            mostrarToast('sucesso', 'Usuário autenticado com sucesso!')
            props.validacaoSubmit(props.propsFormikOriginal?.values, props.propsFormikOriginal)
        }, () => setIsSubmit(false), false))
    }

    return (
        <Formik
            initialValues={valoresIniciais}
            validationSchema={validacaoInicial}
            enableReinitialize={true}
            onSubmit={(values) => Submit(values, setIsSubmit, props.setShow)}>
            {propsFormik => (
                <Form>
                    <div className="modal-body-cadastro">
                        <div class="separator mt-20 mb-20"></div>
                        <div className={'form-group col-12'}>
                            <InputPadrao label="Id" name="usuario_solicitante_id" type="hidden" placeholder="Id" obrigatorio="false" classeTooltip={props.modal ? "tooltip-input-modal" : ""} />
                            <InputPadrao label={<b>Login</b>} name="login" type="input" placeholder="Login" obrigatorio="true"
                                classeTooltip={"tooltip-input-modal"} tamanho={'col-lg-12 p-0'} autoFocus />
                            <InputGroupSenha label={<b>Senha</b>} obrigatorio classeTooltip={"tooltip-input-modal"} tamanho={'col-lg-12 p-0'} name='senha' placeholder='Senha' />
                            <TextArea
                                label={<b>Justificativa Autorização</b>}
                                name="justificativa"
                                type="text"
                                placeholder="Justificativa Autorização"
                                tamanho={'col-lg-12 p-0'}
                                obrigatorio={true}
                                propsFormik={propsFormik}
                                classeTooltip={"tooltip-input-modal"}
                            />
                        </div>
                    </div>

                    <div className="separator mt-40 mb-2"></div>
                    <Atalho formik={propsFormik} salvando={false} />

                    <div className="row justify-content-center">
                        <div className="container-botoes direita">
                            <BotaoPadrao classe="btn btn-secundario btn-sm m-1" type="button" texto="Cancelar" disabled={isSubmit} click={() => props.setShow(false)} />
                            <BotaoPadrao texto="Salvar" disabled={isSubmit} idTooltip={'salvar'} />
                        </div>
                    </div>
                </Form>)
            }
        </Formik>
    )
}

export default AutorizacaoSenha